import styled from 'styled-components';


export const ArticleListItem = styled.a`
	background-color: #fff;
	border-radius: 6px;
	padding: 12px;
	display: block;
	
	.title {
		font-size: 16px;
		font-weight: 600;
		color: #333!important;
		margin-bottom: 10px;
	}
	.description {
		font-size: 15px;
		color: #333!important;
		margin-bottom: 10px;
	}
	
	.article-tag {
		font-size: 14px;
		color: #757575!important;
	}
	
	img.cover {
		width: 100%;
		height: 150px;
		object-fit: cover;
		border-radius: 4px;
		margin-bottom: 21px;
	}
`

export const ArticleGridItem = styled.article`
	display: flex;
	flex-flow: column;
	picture {
		img {
			width: 100%;
			border-radius: 5px;
		}
	}
		.publish-date {
			display: flex;
			align-items: center;
			font-size: 15px;
			color: #001644;

			i {
				border-radius: 50%;
				background-color: #FF7C54;
				display: inline-flex;
				width: 21px;
				height: 21px;
				align-items: center;
				justify-content: center;
				margin-right: 10px;
				img {
					width: 10px;
				}
			}
		}

		desc {
			color: #001644;
			font-size: 18px;
			font-style: normal;
			font-weight: 400;
			line-height: normal;
			letter-spacing: -0.18px;
			margin-bottom: 10px;
		}

		a.article-link {
			color: #001644;
			font-size: 20px;
			font-style: normal;
			font-weight: 700;
			line-height: normal;
			margin: 30px 0 15px;
		}
`

export const ListLayout = styled.div`

`
export const GridLayout = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-template-rows: auto;
	grid-column-gap: 18px;
	grid-row-gap: 28px;
	
	article:not(:first-child) {
		a.article-link {
			margin: 18px 0 10px;
		}
		> p {
			display: none;
		}
		picture {
			img {
				max-height: 240px;
				height: 30vw;
				object-fit: cover;
			}
		}
		
		@media all and (min-width: 992px) {
			picture {
				img {
					max-height: 220px;
					height: 15vw;
				}
			}
		}
		
	}
	
	article:first-child {
		grid-column-start: 1;
		grid-column-end: 3;
		grid-row-start: 1;
		grid-row-end: 3;
		margin-bottom: 15px;
	}

	@media all and (min-width: 992px) {
		grid-template-columns: 1fr 1fr 1fr 1fr;
		grid-template-rows: auto auto;
		margin-bottom: 0;
	}
`
